import React from "react";
import "./separators.scss";

const Separator2 = () => {
  return (
    <div className="separator2">
      <div className="separator2__content">
        <p className="separator2__content__text">
          El resultado de la búsqueda de la satisfacción fue que nuestros
          Clientes se han incrementado y seguiremos creciendo y buscando
          soluciones para los clientes en el mantenimiento, restauración y
          limpieza de sus lugares de trabajo o residencia.
        </p>
      </div>
    </div>
  );
};

export default Separator2;
